'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getCurrentMeeting = getCurrentMeeting;
exports.getDisplayModeState = getDisplayModeState;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _chatreducer = require('./chatreducer');

var _chatreducer2 = _interopRequireDefault(_chatreducer);

var _store = require('../common/store');

var _store2 = _interopRequireDefault(_store);

var _constants = require('../common/constants');

var Constants = _interopRequireWildcard(_constants);

var _chatbox = require('./chatbox');

var _chatbox2 = _interopRequireDefault(_chatbox);

var _helpers = require('../common/helpers');

var _userservice = require('../services/userservice');

var _userservice2 = _interopRequireDefault(_userservice);

var _messagedispatcher = require('./messagedispatcher');

var _messagedispatcher2 = _interopRequireDefault(_messagedispatcher);

var _messagecomposer = require('./messagecomposer');

var _messagecomposer2 = _interopRequireDefault(_messagecomposer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import mqttclient from '../../../mqttclient/lib/mqttclient'


var Chat = function (_Component) {
    _inherits(Chat, _Component);

    function Chat(props) {
        _classCallCheck(this, Chat);

        var _this = _possibleConstructorReturn(this, (Chat.__proto__ || Object.getPrototypeOf(Chat)).call(this, props));

        _this.loadParticipantList = function () {
            _this.props.dispatch((0, _chatreducer.loadParticipants)(_this.props.meetingId));
        };

        _this.ifDeckMinimised = function () {
            if (_this.deckMode === 'minimised') {
                if (_this.unreadMessageCount) {
                    _this.unreadMessageCount = _this.unreadMessageCount + 1;
                } else {
                    _this.unreadMessageCount = 1;
                }
                _this.props.changeUnreadMessageCount(_this.unreadMessageCount);
            }
        };

        _this.setDeckMode = function (newDeckMode) {
            _this.deckMode = newDeckMode;
        };

        _this.loadHistoryMessages = function () {
            _this.props.dispatch((0, _chatreducer.loadHistoryMessages)(_this.props.meetingId));
        };

        _this._onConnectionStatusChange = function (data) {
            console.log('mqttclient connection status for clientId ' + data.clientId + ' is ' + data.status);
            if (data.status === Constants.MQTT_ONLINE) {
                //MQTT clean session is set false. So it will automatically reconnect to topic.
                // this._reSubscribe()
            } else {
                // perform some UI change to indicate user is offline
                _this.setState({ isSubscribed: false });
            }
        };

        _this._reSubscribe = function () {
            (0, _helpers.getChatConfig)().mqttService.unsubscribe({ topic: _this.topic, qos: Constants.MQTT_QOS, callback: _this.onMessageReceived });
            (0, _helpers.getChatConfig)().mqttService.subscribe({ topic: _this.topic, qos: Constants.MQTT_QOS, callback: _this.onMessageReceived }, _this.onSubscribe);
        };

        _this.state = {
            isSubscribed: false
        };
        _this.user = null;
        _this.onSubscribe = _this.onSubscribe.bind(_this);
        _this.onMessageEntered = _this.onMessageEntered.bind(_this);
        _this.onMessageReceived = _this.onMessageReceived.bind(_this);
        _this.setDisplayMode = _this.setDisplayMode.bind(_this);
        _this.setTypingMessage = _this.setTypingMessage.bind(_this);
        _this.setLastTypedMessage = _this.setLastTypedMessage.bind(_this);
        _this.setUnreadMessageCount = _this.setUnreadMessageCount.bind(_this);

        var mqtt_topic = _userservice2.default.getMqttBasename();
        if (!mqtt_topic) {
            mqtt_topic = TOPIC_BASENAME;
        }
        _this.topic = mqtt_topic + "chat/meeting/" + _this.props.meetingId;

        _this.messageDispatcher = new _messagedispatcher2.default(_this);
        _this.messageComposer = new _messagecomposer2.default(_this);
        _this.shareFiles = _this.shareFiles.bind(_this);

        //deck related variables
        _this.deckMode = 'maximised';
        _this.unreadMessageCount = null;
        return _this;
    }

    _createClass(Chat, [{
        key: 'onMessageEntered',
        value: function onMessageEntered(action, text) {
            console.log("Message Entered: ", action, " ", text);
            return this.messageComposer.messageHandler(action, text);
        }
    }, {
        key: 'onSubscribe',
        value: function onSubscribe(err, res) {
            if (err) {
                console.error('Error subscribing ' + this.topic + ' topic ' + err);
            } else {
                console.log('Successfully subscribed topic ' + this.topic + ' with grantedQOS ' + res.data.grantedQos[0]);
                var chat = {
                    meetingId: this.props.meetingId,
                    meetingTitle: this.props.meetingTitle,
                    chatteeName: this.props.chatteeName,
                    messages: [],
                    participants: [],
                    userTypingProperties: [],
                    type: Constants.CHAT_TYPE_GROUP,
                    displayMode: this.props.displayMode ? this.props.displayMode : getDisplayModeState(this.props.meetingId),
                    lastTypedMessage: getLastTypedMessage(this.props.meetingId) ? getLastTypedMessage(this.props.meetingId) : "",
                    unReadMessageCount: getUnreadMessageCount(this.props.meetingId) ? getUnreadMessageCount(this.props.meetingId) : 0
                };

                this.props.dispatch((0, _chatreducer.updateUnreadMessagecount)({
                    meetingId: this.props.meetingId,
                    unreadMessagecount: chat.unReadMessageCount
                }));
                this.props.dispatch((0, _chatreducer.updateLastTypedMessage)({
                    meetingId: this.props.meetingId,
                    message: chat.lastTypedMessage
                }));
                this.props.dispatch((0, _chatreducer.updateDisplayMode)({
                    meetingId: this.props.meetingId,
                    displayMode: chat.displayMode
                }));

                this.props.dispatch((0, _chatreducer.addChat)(chat));

                this.props.dispatch((0, _chatreducer.updateDisplayMode)({
                    meetingId: this.props.meetingId,
                    displayMode: chat.displayMode
                }));
                this.props.dispatch((0, _chatreducer.addUser)(this.user));
                this.props.dispatch((0, _chatreducer.userJoin)({
                    meetingId: this.props.meetingId,
                    user: this.user
                }));
                this.props.dispatch((0, _chatreducer.setCurrentMeeting)(this.props.meetingId));
                this.props.dispatch((0, _chatreducer.updateParticipant)(this.props.participants));
                this.loadHistoryMessages();
                this.setState({ isSubscribed: true });
                console.log('before... mqtt join action called ', this.props);
                this.messageComposer.messageHandler(Constants.MESSAGE_ACTION_JOIN, {
                    meeting_Id: this.props.meetingId,
                    sender_Id: this.user.id,
                    user_Name: this.props.chatteeName
                }, true);

                if (this.props.initialMessage) {
                    // this.onMessageEntered(Constants.MESSAGE_ACTION_SUBMIT, this.props.initialMessage)
                }
            }
        }
    }, {
        key: 'shareFiles',
        value: function shareFiles(files) {
            console.log(files);
            return this.messageComposer.messageHandler(Constants.CHAT_ACTION_FILE_SHARE, { caption: "my-bday-photos", localFileUrls: files }, false);
        }
    }, {
        key: 'onFileUploadComplete',
        value: function onFileUploadComplete(e) {
            if (e.progress.percent === 100) {
                var message = e.context.message;
                return this.messagecomposer.messageHandler('file-share', { caption: message.caption, remoteFileUrls: e.context.remoteFiles });
            }
        }
    }, {
        key: 'onMessageReceived',
        value: function onMessageReceived(packet) {
            // console.log("Chat::onMessageReceived packettt:" + JSON.stringify(packet))
            var payload = JSON.parse(packet.payload);
            this.messageDispatcher.dispatch(packet);
            if (payload.data.sender_id !== this.props.chatteeId && payload.action === Constants.CHAT_ACTION_MESSAGE_NEW) {
                this.ifDeckMinimised();
            }
        }
    }, {
        key: 'setDisplayMode',


        //Maintaining redux state of chat window state. 
        value: function setDisplayMode(displayMode) {
            this.props.dispatch((0, _chatreducer.updateDisplayMode)({ meetingId: this.props.meetingId, displayMode: displayMode }));
        }
    }, {
        key: 'setTypingMessage',
        value: function setTypingMessage(data) {
            this.props.dispatch((0, _chatreducer.updateTypingMessage)({
                meetingId: this.props.meetingId,
                sender_id: data.sender_id,
                message: data.message
            }));
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            _userservice2.default.get().then(function (res) {
                _this2.user = res;
            });
            this.setDeckMode(this.props.deckMode);
            (0, _helpers.getChatConfig)().mqttService.addConnectionStatusChangeCallback(this._onConnectionStatusChange);
            (0, _helpers.getChatConfig)().mqttService.subscribe({ topic: this.topic, qos: Constants.MQTT_QOS, callback: this.onMessageReceived }, this.onSubscribe);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.deckMode !== nextProps.deckMode) this.setDeckMode(nextProps.deckMode);

            if (this.deckMode === 'maximised') {
                this.unreadMessageCount = null;
                this.props.changeUnreadMessageCount(this.unreadMessageCount);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            // console.log("participants: " + JSON.stringify(this.props.participants))
            console.log("Props of chat component  : ", this.props);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // do proper cleanup
            this.props.dispatch((0, _chatreducer.userLeave)({ meetingId: this.props.meetingId, user: this.user }));
            (0, _helpers.getChatConfig)().mqttService.unsubscribe({ topic: this.topic, qos: Constants.MQTT_QOS, callback: this.onMessageReceived });
            (0, _helpers.getChatConfig)().mqttService.removeConnectionStatusChangeCallback(this._onConnectionStatusChange);
        }
    }, {
        key: 'setLastTypedMessage',
        value: function setLastTypedMessage(message) {
            this.props.dispatch((0, _chatreducer.updateLastTypedMessage)({
                meetingId: this.props.meetingId,
                message: message
            }));
        }
    }, {
        key: 'setUnreadMessageCount',
        value: function setUnreadMessageCount(count) {
            this.props.dispatch((0, _chatreducer.updateUnreadMessagecount)({
                meetingId: this.props.meetingId,
                unreadMessagecount: count
            }));
        }
    }, {
        key: 'render',
        value: function render() {
            console.log("Display Mode chat.js: ", this.props.displayMode);
            var props = this.props;
            var chat = this.props.chat;
            var messages = void 0,
                participants = void 0,
                historyMessagesUrl = void 0,
                user_typing_messages = void 0,
                displayMode = void 0,
                lastTypedMessage = void 0,
                unReadMessageCount = void 0,
                isMeetingEnded = void 0;
            if (chat) {
                displayMode = chat.displayMode; // ? chat.displayMode : Constants.CHAT_WINDOW_STATE_MINIMIZED
                messages = chat.messages ? chat.messages : [];
                participants = chat.participants ? chat.participants : [];
                historyMessagesUrl = chat.historyMessagesUrl;
                user_typing_messages = chat.userTypingProperties ? chat.userTypingProperties : [];
                lastTypedMessage = chat.lastTypedMessage ? chat.lastTypedMessage : "";
                unReadMessageCount = chat.unReadMessageCount ? chat.unReadMessageCount : 0;
                isMeetingEnded = chat.meetingEnded;
            }
            var chatteeId = -1,
                chatteeName = "unknown";
            if (this.user) {
                chatteeId = this.user.id;
                chatteeName = this.user.type;
            }

            return _react2.default.createElement(
                'div',
                { id: 'chat-element' },
                _react2.default.createElement(
                    _chatbox2.default,
                    {
                        user: this.user,
                        isLoading: false,
                        isMeetingEnded: isMeetingEnded,
                        messages: messages,
                        user_typing_messages: user_typing_messages,
                        historyMessagesUrl: historyMessagesUrl,
                        participants: participants,
                        chatteeName: chatteeName,
                        chatteeId: chatteeId,
                        position: props.position,
                        sharefiles: this.shareFiles,
                        callBackFunction: (0, _helpers.getChatConfig)().callBacks,
                        loadHistoryMessages: this.loadHistoryMessages,
                        skinName: props.skinName,
                        onMessageEntered: this.onMessageEntered,
                        user_type: props.user_type,
                        initialMessage: props.initialMessage,
                        chatElement: props.chatElement,
                        user_pic: props.user_pic,
                        displayMode: displayMode,
                        showHeader: props.showHeader,
                        showBody: props.showBody,
                        showFooter: props.showFooter,
                        setDisplayMode: this.setDisplayMode,
                        setTypingMessage: this.setTypingMessage,
                        width: this.props.width,
                        height: this.props.height,
                        mask_user_events: this.props.mask_user_events,
                        mask_user_typing_text: this.props.mask_user_typing_text,
                        loadParticipantList: this.loadParticipantList,
                        setLastTypedMessage: this.setLastTypedMessage,
                        lastTypedMessage: lastTypedMessage,
                        unReadMessageCount: unReadMessageCount },
                    this.props.children
                )
            );
        }

        // private functions

    }]);

    return Chat;
}(_react.Component);

Chat.propTypes = {
    initialMesage: _propTypes2.default.string,
    meetingId: _propTypes2.default.number.isRequired,
    chatteeName: _propTypes2.default.string,
    chatteeId: _propTypes2.default.number,
    position: _propTypes2.default.string,
    meetingTitle: _propTypes2.default.string,
    skinName: _propTypes2.default.string,
    messages: _propTypes2.default.array
};

Chat.defaultProps = {
    initialMesage: "",
    meetingTitle: 'This meeting is about?',
    chatteeName: 'Guest',
    chatteeId: -1,
    position: 'right-bottom',
    skinName: 'red',
    messages: [],
    displayMode: ''

    // static vars
};Chat.Store = Chat.Store ? Chat.Store : new _store2.default(Constants.NS_CHAT, { chatState: _chatreducer2.default });

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        chat: state.chatState.chats.find(function (chat) {
            return chat.meetingId === ownProps.meetingId;
        }),
        user: state.chatState.user
    };
};

// export helper methods
function getCurrentMeeting() {
    var chat = localStorage.getItem(Constants.NS_CHAT);
    if (chat) {
        chat = JSON.parse(chat);
        return chat.chatState && chat.chatState.currentMeeting ? chat.chatState.currentMeeting : null;
    } else {
        return null;
    }
}

// export function removeMeeting(meetingId) {
//     this.dispatch(removeChat(meetingId))
// }

// export helper methods
function getDisplayModeState(meetingId) {
    var chatWindowState = null;
    var chat = localStorage.getItem(Constants.NS_CHAT);
    if (chat) {
        chat = JSON.parse(chat);
        if (chat.chatState && chat.chatState.chats) {
            chat = chat.chatState.chats.find(function (chat, i) {
                if (chat.meetingId === meetingId) {
                    chatWindowState = chat.displayMode;
                    return true;
                } else {
                    return false;
                }
            });
        }
        return chatWindowState;
        // return (chat.displayMode) ? chat.displayMode : null
    } else {
        return null;
    }
}

function getLastTypedMessage(meetingId) {
    var lastTypedMessage = null;
    var chat = localStorage.getItem(Constants.NS_CHAT);

    if (chat) {
        chat = JSON.parse(chat);
        if (chat.chatState && chat.chatState.chats) {
            chat = chat.chatState.chats.find(function (chat, i) {
                if (chat.meetingId === meetingId) {
                    lastTypedMessage = chat.lastTypedMessage ? chat.lastTypedMessage : null;
                    return true;
                } else {
                    return false;
                }
            });
        }
        return lastTypedMessage;
    } else {
        return null;
    }
}

function getUnreadMessageCount(meetingId) {
    var unreadMessages = null;
    var chat = localStorage.getItem(Constants.NS_CHAT);

    if (chat) {
        chat = JSON.parse(chat);
        if (chat.chatState && chat.chatState.chats) {
            chat = chat.chatState.chats.find(function (chat, i) {
                if (chat.meetingId === meetingId) {
                    unreadMessages = chat.unReadMessageCount ? chat.unReadMessageCount : 0;
                    return true;
                } else {
                    return false;
                }
            });
        }
        console.log("Redux Chat State: ", unreadMessages);
        return unreadMessages;
    } else {
        return 0;
    }
}

// export function initialize({clientId, token}) {
//     return new Promise((resolve, reject) => {
//         if (MqttClient.isConnected) {
//             resolve({clientId})
//         }
//         clientId = "$cid::" + clientId + "$r::" + Math.floor((Math.random() * 1000) + 1);
//         const conOpts = {clientId, port:Constants.MQTT_PORT, host:Constants.MQTT_HOST, autoConnect:true}
//         MqttClient
//             .connect(conOpts, function (err, data) {
//                 if (err) {
//                     console.error(`Error connecting mqtt: ${JSON.stringify(err)}`)
//                     reject(err)
//                 } else {
//                     console.log(`${clientId} successfully connected`)
//                     resolve(data)
//                 }
//             })
//     })
// }

exports.default = (0, _store.connectWithStore)(Chat.Store.getStore(), Chat, mapStateToProps);


// WEBPACK FOOTER //
// ../chat/lib/components/chat.js